import indexedDB from '@/services/IndexedDBService'

class NoteMeta {
  constructor() {
    this.representedResourceCounter = 0
    this.representedResourceSize = 0
  }

  setupRepresentedResource() {
    // console.trace()
    this.representedResourceCounter = 3
    this.representedResourceSize = 0
  }

  async removeNoteRepresentedResourceGuid(noteGuid) {
    await indexedDB.notemetas.delete(noteGuid)
  }
  async getNoteRepresentedResourceGuid(noteGuid) {
    let meta = await indexedDB.notemetas.get(noteGuid)
    // console.log(meta)
    if (meta && meta.representedResourceGuid) {
      return meta.representedResourceGuid
    }
    return undefined
  }
  async putNoteRepresentedResourceGuid(noteGuid, resourceGuid, size) {
    // console.log(noteGuid, resourceGuid)
    // 初回はsizeがゼロ？？
    // console.log('size', size)
    if (size < 20000) {
      return // 足切り
    }

    // 初回はindexedDB遅延により情報が揃わない→これを前提にローカル値を使う
    let meta = (await indexedDB.notemetas.get(noteGuid)) || {}
    // console.log('-------', meta.representedResourceGuid)
    if (meta && meta.representedResourceGuid) {
      //   console.log(
      //     this.representedResourceCounter,
      //     this.representedResourceSize,
      //     size
      //   )
      if (this.representedResourceCounter > 0) {
        this.representedResourceCounter = this.representedResourceCounter - 1
        if (this.representedResourceSize * 1.1 > size) {
          //   console.log('[1] under')
          return
        } else {
          //   console.log('[2] retry')
        }
      } else {
        // console.log('[3] pass')
        return
      }
    } else {
      this.representedResourceCounter = this.representedResourceCounter - 1
    }
    if (!(meta && meta.guid)) {
      meta = { guid: noteGuid }
    }
    this.representedResourceSize = size
    meta['representedResourceGuid'] = resourceGuid
    indexedDB.notemetas.put(meta).then(() => {})
  }
}
const noteMeta = new NoteMeta()
export default noteMeta
